import React, { Component } from 'react';

class OrganizationalChart extends Component {
    state = {
        data: [
            { _id: '1', parent: null, name: 'Pouya Pezhman', img: '/images/p1.png', roll: 'CEO', isOpen: true },

            { _id: '11', parent: '1', name: 'Hossein Mohseni', img: '/images/p2.png', roll: 'CDO', isOpen: false },
            { _id: '12', parent: '1', name: 'Pedram Pezhman', img: '/images/p3.png', roll: 'Technical Lead & Co-Founder', isOpen: false },
            { _id: '13', parent: '1', name: 'Hossein Morhedi', img: '/images/p4.png', roll: 'Technical Lead', isOpen: false },
            { _id: '14', parent: '1', name: 'David Johns', img: '/images/p5.png', roll: 'Technical Lead', isOpen: false },

            { _id: '111', parent: '11', name: 'Nastaran Javid', img: '/images/p5.png', roll: 'Front-End Developer', isOpen: false },
            { _id: '112', parent: '11', name: 'Sepehr Hassani', img: '/images/p6.png', roll: 'Front-End Developer', isOpen: false },
            { _id: '113', parent: '11', name: 'Alireza Ozar', img: '/images/p7.png', roll: 'Front-End Developer', isOpen: false },

            { _id: '121', parent: '12', name: 'Mohammadreza Anguti', img: '/images/p1.png', roll: 'Back-End Developer', isOpen: false },
            { _id: '122', parent: '12', name: 'Parna Azizi', img: '/images/p2.png', roll: 'Back-End Developer', isOpen: false },
            { _id: '123', parent: '12', name: 'Ali Panahi', img: '/images/p3.png', roll: 'Back-End Developer', isOpen: false },

            { _id: '131', parent: '13', name: 'Amirreza Qhaforian', img: '/images/p4.png', roll: 'Back-End Developer', isOpen: false },
            { _id: '132', parent: '13', name: 'Amin Dehqan', img: '/images/p5.png', roll: 'Front-End Developer', isOpen: false },
            { _id: '133', parent: '13', name: 'Shahrzad Serajpour', img: '/images/p6.png', roll: 'Graphic Designer', isOpen: false },

            { _id: '141', parent: '14', name: 'Amirreza Qhaforian', img: '/images/p4.png', roll: 'Back-End Developer', isOpen: false },
            { _id: '142', parent: '14', name: 'Amin Dehqan', img: '/images/p5.png', roll: 'Front-End Developer', isOpen: false },
            { _id: '143', parent: '14', name: 'Shahrzad Serajpour', img: '/images/p6.png', roll: 'Graphic Designer', isOpen: false },

            { _id: '1111', parent: '111', name: 'Nastaran Javid', img: '/images/p5.png', roll: 'Front-End Developer', isOpen: false },
            { _id: '1112', parent: '111', name: 'Sepehr Hassani', img: '/images/p6.png', roll: 'Front-End Developer', isOpen: false },
            { _id: '1113', parent: '111', name: 'Alireza Ozar', img: '/images/p7.png', roll: 'Front-End Developer', isOpen: false },
        ],
    };

    componentDidMount = () => {
        let data = this.state.data
        for (let i = 0; i < data.length; i++) {
            const item = data[i];
            item.childrens = []
            for (let j = 0; j < data.length; j++) {
                const element = data[j];

                if (element.parent === item._id) {
                    item.childrens.push(element)
                }
            }
        }
        this.setState({ data }, () => {
            // console.log('dataaaaaaaaaaa', this.state.data)
        })
    }

    toggleOpen = (itemId) => {
        this.setState((prevState) => {
            let activeChildren = prevState.data.find((item) => item.parent === itemId)?._id
            let activeParent = prevState.data.find((item) => item._id === itemId).parent;
            if (activeChildren) {
                let newData = prevState.data.map((item) => {
                    if (item._id === itemId) {
                        if (item.isOpen === false) {
                            for (let i = 0; i < this.state.data.length; i++) {
                                const element = this.state.data[i];
                                if (element.parent === item._id) {
                                    element.isOpen = false
                                }
                            }
                        }
                        return { ...item, isOpen: !item.isOpen };
                    } else if (item.parent === activeParent) {
                        return { ...item, isOpen: false };
                    } else {
                        return item;
                    }
                });
                return { data: newData };
            } else {
                let newData = prevState.data.map((item) => {
                    if (item._id === itemId) {
                        console.log(item, 'itemclg')
                        for (let i = 0; i < this.state.data.length; i++) {
                            const element = this.state.data[i];
                            if (element.parent == item.parent) {
                                console.log(element, 'elementclg')
                                element.isOpen = false
                            }
                        }
                        return { ...item, isOpen: false };
                    }
                    else {
                        return item;
                    }
                });
                return { data: newData };
            }
        });
    };



    showChildren = (data, parent) => {
        return (
            <div className="d-flex">
                <div>
                    {data.map((prop) => {
                        if (prop.parent === parent) {
                            return (
                                <div className="" style={{}} key={prop._id}>
                                    <div className="">
                                        <div className="flexc m-3 p-2 br-20 cursor-pointer" style={{ backgroundColor: prop.isOpen === true ? '#5856D6' : '#eee', width: '250px', position: 'relative' }} onClick={() => this.toggleOpen(prop._id)}>
                                            <img className="br-15" width={50} src={prop.img} alt={prop.name} />
                                            <div className="mld-3">
                                                <p className="font-size-14 weight-600" style={{ color: prop.isOpen === true ? '#fff' : '#444' }}>{prop.name}</p>
                                                <p className="font-size-12 weight-400" style={{ color: prop.isOpen === true ? '#f6f6f6' : '#777' }}>{prop.roll}</p>
                                            </div>
                                            <div className='flexcc br-20' style={{ backgroundColor: prop.isOpen === true ? '#eee' : '#5856D6', position: 'absolute', right: -10, width: '20px', height: '20px' }}>
                                                {!prop.isOpen && (
                                                    <p className={"font-size-12 weight-400 " + (prop.isOpen === true ? 'main-c5' : 'white')}>{prop?.childrens?.length}</p>
                                                )}
                                                {prop.isOpen && (
                                                    <img width={18} src='/assets/icons/arrow-right-gray.svg' />
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            );
                        }
                        return null;
                    })}
                </div>
                <div>
                    {data.map((prop) => {
                        if (prop.parent === parent && prop.isOpen) {
                            return (
                                <div className="d-flex flex-column" style={{ borderLeft: '1px solid #ddd' }}>
                                    {this.showChildren(data, prop._id)}
                                </div>
                            )
                        }
                    })}
                </div>
            </div>
        );
    };

    render() {
        return (
            <div className="w-100 h-100 window-content-radius" style={{ backgroundColor: '#f6f6f6' }}>
                <div className="sc-gray" style={{overflow:'auto'}}>
                    {this.showChildren(this.state.data, null)}
                </div>
            </div>
        );
    }
}

export default OrganizationalChart;
